import getSupportedLocale from "../../helpers/getSupportedLocale"
import env from "../../../env"
import {getLocaleUrl} from "../../../links"

export default function getUrl(bucketName: string, rawLocale: string) {
  const locale = getSupportedLocale(rawLocale)
  // the is_local check will allow getting the latest phrase keys without restarting the dev server
  return `${getLocaleUrl()}/locale/web/${locale}/${bucketName}.json?${env.IS_LOCAL ? new Date().getTime() : env.BUNDLE_REF}`.toLowerCase()
}
